//#region Utils
import { errorFree } from "utils/validations";
//#endregion

//#region Validators
const isValidFormStep1 = (step1) => {
    const { acadReinforceTypeId, course } = step1.part1;
    const { tutor, payGradeId } = step1.part2;
    const { quantityVacancy, publicLoad } = step1.part3;
    const newErrors = {
        part1: {
            acadReinforceTypeId: acadReinforceTypeId === 0,
            course: course.id.length === 0
        }, 
        part2: {
            tutor: tutor.id.length === 0,
            payGradeId: payGradeId.length === 0
        }, 
        part3: {
            quantityVacancy: Boolean(!quantityVacancy.trim() || parseInt(quantityVacancy) <= 0), 
            publicLoad: {
                id: publicLoad?.id === 0, 
                students: {
                    publicByCampusIds: false, 
                    modalityId: false
                }, 
                list: {
                    studentsFile: false
                }
            }
        }
    };
    if (publicLoad.id === 1 || !publicLoad?.id) {
        const { publicByCampusIds, modalityId } = publicLoad.students;
        newErrors.part3.publicLoad.students = {
            publicByCampusIds: publicByCampusIds.length === 0, 
            modalityId: modalityId === 0
        };
    }
    else if (publicLoad.id === 2) {
        const { studentsFile } = publicLoad.list;
        newErrors.part3.publicLoad.list = {
            studentsFile: !studentsFile.name
        };
    }
    const isValid = errorFree(newErrors);
    return {
        isValid, newErrors
    };
}
const fillErrorsPlace = ({ 
    campus, environmentTypeId,
    environmentFillingTypeId,
    environment, otherEnvironment 
}, newErrors) => {
    newErrors.part3.place = {
        ...newErrors.part3.place,
        campus: campus.id === 0,
        environmentTypeId: environmentTypeId.length === 0
    };
    if (environmentFillingTypeId === 1) {
        newErrors.part3.place.environment = environment.id.length === 0;
        return;
    }
    if (environmentFillingTypeId === 2) {
        const {
            envName, address,
            floor, capacity
        } = otherEnvironment;
        newErrors.part3.place.otherEnvironment = {
            envName: envName.length === 0,
            address: address.length === 0,
            floor: floor.length === 0,
            capacity: capacity.length === 0
        };
    }
}
const isValidFormStep2 = (step2) => {
    const { duration: { date, time }} = step2.part2;
    const { locationId, zoomInscriptionTypeId, place } = step2.part3;
    const errorTime = {
        start: time.start <= -1,
        end: time.end <= -1
    };
    const newErrors = {
        part2: {
            duration: {
                date: date <= -1, 
                time: errorTime,
                areInvalidTimes: (
                    !errorTime.start && 
                    !errorTime.end && 
                    time.start >= time.end
                )
            }
        },
        part3: {
            locationId: locationId === 0,
            zoomInscriptionTypeId: false, 
            place: {
                campus: false,
                environmentTypeId: false,
                environment: false,
                otherEnvironment: {
                    envName: false,
                    address: false,
                    floor: false,
                    capacity: false
                }
            }
        }
    };
    if (locationId === 1) 
        newErrors.part3.zoomInscriptionTypeId = zoomInscriptionTypeId === 0;
    else if (locationId === 2) 
        fillErrorsPlace(place, newErrors);
    const isValid = errorFree(newErrors);
    return {
        isValid, newErrors
    };
}
//#endregion
const validations = {
    isValidFormStep1, isValidFormStep2
};
export default validations;